/**
 * Iterate over two iterators in tandem, stopping when the shorter is
 * exhausted.
 */



export const zip = function* <A, B>(a: Iterable<A>, b: Iterable<B>): Generator<[A, B]> {
    const ai = a[Symbol.iterator]();
    const bi = b[Symbol.iterator]();

    let ar = ai.next();
    let br = bi.next();
    let done = ar.done || br.done;

    while (!done) {
        yield [ar.value, br.value];

        ar = ai.next();
        br = bi.next();
        done = ar.done || br.done;
    }
};
